module.exports = __webpack_public_path__ + "media/images/illus green note-0e796601b7e5a5eb6a46b46e1eac70d4.png";